import { CityRO } from '@routellers/types/dist/city/city.ro';
import { CountriesEnum } from '@routellers/types/dist/shared/enum/countries.enum';

import { ApiMethodDeclaration } from '..';

type ParamsData = {
    country?: CountriesEnum;
};

type ResponseData = CityRO[];

export const getPopularForAdmin: ApiMethodDeclaration<ParamsData, ResponseData> = ({
    country,
}) => ({
    url: `/cities/admin/popular/${country ? `?country=${country}` : ''}`,
    method: 'GET',
});
